import { PapiDeviation } from '@wix/da-papi-types';

export const tierDeviations: PapiDeviation[] = [
  testTier() as any,
  {
    ...testTier(),
    deviationId: 860114816,
    url: 'https://www.deviantart.lan/spiraloso/tier/Mage--3-Videos-of-illustration-lesson-Package-15-Month-860114816',
    title: 'Test tier 2',
    extended: extended(),
    tier: {
      tierId: 2,
      isUserSubscribed: false,
      canUserSubscribe: true,
      state: 'active',
      subproductId: 2,
      dollarPrice: '15.00',
      stats: {
        subscribers: 1,
      },
      benefits: [
        'Includes everything from Apprentice Tier',
        'Hi-Res Process Photos',
        "Patron 'Quicktique' Paintover Demo",
        'Classic Timelapse Speedpaint Video',
      ],
    },
  },
  {
    ...testTier(),
    deviationId: 860114817,
    url: 'https://www.deviantart.lan/spiraloso/tier/Mage--3-Videos-of-illustration-lesson-Package-20-Month-860114817',
    title: 'Test tier 3',
    tier: {
      tierId: 3,
      isUserSubscribed: false,
      canUserSubscribe: true,
      state: 'active',
      subproductId: 3,
      dollarPrice: '20.00',
      benefits: [
        'Includes everything from Apprentice Tier',
        'Hi-Res Process Photos',
        "Patron 'Quicktique' Paintover Demo",
        'Classic Timelapse Speedpaint Video',
      ],
    },
  },
  {
    ...testTier(),
    deviationId: 860114818,
    url: 'https://www.deviantart.lan/spiraloso/tier/Mage--3-Videos-of-illustration-lesson-Package-25-Month-860114818',
    title: 'Test tier 4',
    tier: {
      tierId: 4,
      isUserSubscribed: false,
      canUserSubscribe: true,
      state: 'active',
      subproductId: 4,
      dollarPrice: '25.00',
      stats: {
        subscribers: 12001,
      },
      benefits: [
        'Includes everything from Apprentice Tier',
        'Hi-Res Process Photos',
        "Patron 'Quicktique' Paintover Demo",
        'Classic Timelapse Speedpaint Video',
      ],
    },
  },
  {
    ...testTier(),
    deviationId: 860114819,
    url: 'https://www.deviantart.lan/spiraloso/tier/Mage--I-ll-just-draw-it-for-you-Package-300-Month-860114819',
    title: 'Test tier 5',
    tier: {
      tierId: 5,
      isUserSubscribed: false,
      canUserSubscribe: true,
      isPendingDeletion: false,
      state: 'active',
      subproductId: 1234,
      dollarPrice: '100.00',
      stats: {
        subscribers: 12001,
      },
      benefits: [
        'Includes everything from Apprentice Tier',
        'Hi-Res Process Photos',
        "Patron 'Quicktique' Paintover Demo",
        'Classic Timelapse Speedpaint Video',
      ],
    },
  },
];

function testTier(): PapiDeviation {
  return {
    deviationId: 860114815,
    extended: extended(),
    media: media(),
    coverImage: coverImage(),
    type: 'tier',
    typeId: 82,
    url: 'https://www.deviantart.lan/spiraloso/tier/Mage--3-Videos-of-illustration-lesson-Package-10-Month-860114815',
    title: 'Mage -3 Videos of illustration lesson Package $10/Month',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    publishedTime: '2020-11-03T08:35:37-0800',
    isTextEditable: true,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    hasPrivateComments: false,
    blockReasons: [],
    license: 'none',
    author: {
      userId: 21997289,
      useridUuid: '6b242645-e0a0-41ca-be34-eb3a910c566c',
      username: 'spiraloso',
      usericon: 'https://a.deviantart.net/avatars-big/s/p/spiraloso.jpg?5',
      type: 'volunteer',
      isWatching: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 10,
      favourites: 3,
    },
    textContent: {
      excerpt:
        "You will get:\n\nQuicktique Paintover - Every package, one patron will get a quick critique and you will see the recorded process. If you want a chance to get a critique submit your art to the discord channel 'Paintover-submissions'. Arch Mage tier has priority for being chosen.",
      html: {
        type: 'draft',
        markup:
          '{"blocks":[{"key":"foo","text":"You will get:","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"8cbsu","text":","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"145mi","text":"Quicktique Paintover - Every package, one patron will get a quick critique and you will see the recorded process. If you want a chance to get a critique submit your art to the discord channel \'Paintover-submissions\'. Arch Mage tier has priority for being chosen.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
        features:
          '[{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}},{"type":"WORD_COUNT_FEATURE","data":{"words":49,"chars":285}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":0,"mentions":0,"video":0,"previews":0}}]',
      },
    },
    tier: {
      tierId: 1,
      isUserSubscribed: false,
      canUserSubscribe: true,
      state: 'active',
      subproductId: 2234,
      dollarPrice: '10.00',
      stats: {
        subscribers: 30,
      },
      settings: {
        accessSettings: 'all',
      },
      benefits: [
        'Includes everything from Apprentice Tier',
        'Hi-Res Process Photos',
        "Patron 'Quicktique' Paintover Demo",
        'Classic Timelapse Speedpaint Video',
      ],
      discord: {
        connected: true,
        oauth2:
          'https://discord.com/oauth2/authorize?client_id=979802510766268446&response_type=token&scope=bot+identify&permissions=268437507&redirect_uri=https%3A%2F%2Fwww.deviantart.com%2F_sisu%2Foauth%2Fdiscord%2Fconnect',
        connectedRoles: ['Role 1', 'Role 2', 'Role 3'],
      },
    },
  };
}

function coverImage(): PapiDeviation {
  return {
    deviationId: 2725397937603809,
    type: 'image',
    typeId: 1,
    url: 'https://sta.sh/0qu2mj0cych',
    title: 'Screenshot (20200125-163308)',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    publishedTime: '2020-04-10T05:30:58-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: false,
    hasPrivateComments: false,
    blockReasons: [],
    license: 'none',
    author: {
      userId: 21997289,
      useridUuid: '6b242645-e0a0-41ca-be34-eb3a910c566c',
      username: 'spiraloso',
      usericon: 'https://a.deviantart.net/avatars-big/s/p/spiraloso.jpg?5',
      type: 'volunteer',
      isWatching: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/6b242645-e0a0-41ca-be34-eb3a910c566c/ddui09z-5f6f7c0c-140c-4e30-b004-cbd1d658ed20.jpg',
      prettyName: 'screenshot__20200125_163308__by_spiraloso_ddui09z',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOiIsImlzcyI6InVybjphcHA6Iiwib2JqIjpbW3siaGVpZ2h0IjoiPD03MjAiLCJwYXRoIjoiXC9mXC82YjI0MjY0NS1lMGEwLTQxY2EtYmUzNC1lYjNhOTEwYzU2NmNcL2RkdWkwOXotNWY2ZjdjMGMtMTQwYy00ZTMwLWIwMDQtY2JkMWQ2NThlZDIwLmpwZyIsIndpZHRoIjoiPD0xMjgwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.22wkONkliJfbbKOpX9F57xbR4RABNjDSz2a3vsxtDLM',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOiIsImlzcyI6InVybjphcHA6Iiwib2JqIjpbW3sicGF0aCI6IlwvZlwvNmIyNDI2NDUtZTBhMC00MWNhLWJlMzQtZWIzYTkxMGM1NjZjXC9kZHVpMDl6LTVmNmY3YzBjLTE0MGMtNGUzMC1iMDA0LWNiZDFkNjU4ZWQyMC5qcGcifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6ZmlsZS5kb3dubG9hZCJdfQ.JLse60X0r9Qmp5HKqegmImVMP1VkGZdeGUbzYAYPAsM',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_720,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 1311767,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1280,h_720,q_75,strp/<prettyName>-fullview.jpg',
          h: 720,
          w: 1280,
          f: 1311767,
        },
      ],
    },
  };
}

function extended() {
  return {
    description:
      'You will get:\n' +
      '\n' +
      "Quicktique Paintover - Every package, one patron will get a quick critique and you will see the recorded process. If you want a chance to get a critique submit your art to the discord channel 'Paintover-submissions'. Arch Mage tier has priority for being chosen.\n",
    deviationUuid: '2B4128FC-A8F1-C7BD-A9E9-2F7C5C9204C8',
    canUserAddToGroup: true,
    groupListUrl: 'https://www.deviantart.com/deviation/860114815/groups',
    stats: {
      views: 12,
      today: 4,
      shares: 0,
      downloads: 0,
      groups: 0,
    },
  };
}

function media() {
  return {
    baseUri:
      'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/6b242645-e0a0-41ca-be34-eb3a910c566c/ddui09z-5f6f7c0c-140c-4e30-b004-cbd1d658ed20.jpg',
    prettyName: 'screenshot__20200125_163308__by_spiraloso_ddui09z',
    token: [
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOiIsImlzcyI6InVybjphcHA6Iiwib2JqIjpbW3siaGVpZ2h0IjoiPD03MjAiLCJwYXRoIjoiXC9mXC82YjI0MjY0NS1lMGEwLTQxY2EtYmUzNC1lYjNhOTEwYzU2NmNcL2RkdWkwOXotNWY2ZjdjMGMtMTQwYy00ZTMwLWIwMDQtY2JkMWQ2NThlZDIwLmpwZyIsIndpZHRoIjoiPD0xMjgwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.22wkONkliJfbbKOpX9F57xbR4RABNjDSz2a3vsxtDLM',
    ],
    types: [
      {
        t: '150',
        r: 0,
        c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
        h: 84,
        w: 150,
      },
      {
        t: '200H',
        r: 0,
        c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
        h: 169,
        w: 300,
      },
      {
        t: '300W',
        r: 0,
        c: 'v1/fit/w_300,h_720,q_70,strp/<prettyName>-300w.jpg',
        h: 169,
        w: 300,
      },
      {
        t: '250T',
        r: 0,
        c: 'v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
        h: 250,
        w: 444,
      },
      {
        t: '350T',
        r: 0,
        c: 'v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
        h: 350,
        w: 622,
      },
      {
        t: '400T',
        r: 0,
        c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
        h: 400,
        w: 711,
      },
      {
        t: 'preview',
        r: 0,
        c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
        h: 670,
        w: 1192,
        f: 1311767,
      },
      {
        t: 'social_preview',
        r: 0,
        c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
        h: 670,
        w: 1192,
      },
      {
        t: 'fullview',
        r: 0,
        c: 'v1/fill/w_1280,h_720,q_75,strp/<prettyName>-fullview.jpg',
        h: 720,
        w: 1280,
        f: 1311767,
      },
    ],
  };
}
